import { useState, useEffect, useCallback } from 'react';
import { getPrices } from '../services/api';
import './Portfolio.css';

export default function Portfolio({ holdings, onSelect }) {
  const [prices, setPrices] = useState({});

  const fetchPrices = useCallback(async () => {
    if (holdings.length === 0) return;
    try {
      const tickers = holdings.map((h) => h.ticker);
      const data = await getPrices(tickers);
      const map = {};
      (data.tickers || []).forEach((t) => {
        map[t.ticker] = t.price;
      });
      setPrices(map);
    } catch {
      // silently fail
    }
  }, [holdings]);

  useEffect(() => {
    fetchPrices();
    const interval = setInterval(fetchPrices, 60000);
    return () => clearInterval(interval);
  }, [fetchPrices]);

  if (holdings.length === 0) {
    return <div className="portfolio-empty">No holdings yet. Buy some stocks to get started!</div>;
  }

  const totalValue = holdings.reduce((sum, h) => sum + (prices[h.ticker] || h.avg_price) * h.shares, 0);

  return (
    <div className="portfolio">
      <div className="portfolio-total">
        <span className="portfolio-total-label">Portfolio Value</span>
        <span className="portfolio-total-value">${totalValue.toLocaleString('en-US', { minimumFractionDigits: 2 })}</span>
      </div>
      {holdings.map((h) => {
        const currentPrice = prices[h.ticker] || h.avg_price;
        const pl = (currentPrice - h.avg_price) * h.shares;
        const plPct = ((currentPrice - h.avg_price) / h.avg_price) * 100;
        const isPositive = pl >= 0;

        return (
          <div
            key={h.ticker}
            className="portfolio-item"
            onClick={() => onSelect({ ticker: h.ticker, name: h.ticker })}
          >
            <div className="portfolio-info">
              <span className="portfolio-ticker">{h.ticker}</span>
              <span className="portfolio-shares">{h.shares} shares @ ${h.avg_price.toFixed(2)}</span>
            </div>
            <div className="portfolio-values">
              <span className="portfolio-current">${(currentPrice * h.shares).toFixed(2)}</span>
              <span className={`portfolio-pl ${isPositive ? 'positive' : 'negative'}`}>
                {isPositive ? '+' : ''}{pl.toFixed(2)} ({plPct.toFixed(2)}%)
              </span>
            </div>
          </div>
        );
      })}
    </div>
  );
}
